import { SlideDown } from "react-slidedown";
import { useEffect, useState } from "react";
import tickIcon from "../../assets/icons/tick.svg";
import arrowIcon from "../../assets/icons/arrow-down.svg";
import useIntersection from "../../utilities/useIntersection";

const ContractStatus = ({ buttonRef }) => {
    const [canSign, setCanSign] = useState(false);
    const inViewport = useIntersection(buttonRef, "0px");

    // If the contract button is in the viewport, and the contract was not able to be signed previously, show the second message
    useEffect(() => {
        if (inViewport && !canSign) {
            setCanSign(true);
        }
    }, [inViewport, canSign]);

    const icon = canSign ? tickIcon : arrowIcon;

    const text = canSign ? "You are able to sign your contract now" : "Scroll to read and sign the contract";

    return (
        <div className="contract-status">
            <div className="contract-status__outer">
                <SlideDown className="contract-status__slidedown" closed={false}>
                    <div className="wrap">
                        <div className="contract-status__inner">
                            <div className="contract-status__text">
                                <img src={icon} alt="" />
                                {text}
                            </div>
                        </div>
                    </div>
                </SlideDown>
            </div>
        </div>
    );
};

export default ContractStatus;
